export enum DataType {
    WEB,
    CTX,
    RFP,
    MIS
}
